<template>
  <article
    class="public_coupon_template"
    :class="{ is_clickable: canShowDetail }"
    role="link"
    :tabindex="canShowDetail ? 0 : -1"
    :aria-disabled="!canShowDetail"
    :aria-label="`查看${item.title}詳細資料`"
    @click="onCardClick"
    @keydown="onCardKeydown"
  >
    <couponImage :image="item.image" variant="thumbnail" />
    <div class="public_coupon_content">
      <h3 class="text_two_lines">{{ item.title }}</h3>
      <p v-if="item.description" class="public_coupon_description text_two_lines">
        {{ item.description }}
      </p>
      <p class="public_coupon_period">
        領取期間<br />{{ getClaimBeginText }} ～ {{ getClaimEndText }}
      </p>
    </div>
    <button
      class="coupon_action"
      type="button"
      :disabled="!canShowDetail"
      @click.stop="showDetail"
    >
      領取優惠券
    </button>
  </article>
</template>
<script>
import { COUPON_DATE_FORMAT, formatCouponDateTime } from "@/utils/coupon.utils";
import couponImage from "@/components/coupon/couponImage.vue";
export default {
  components: { couponImage },
  props: {
    item: { type: Object, required: true },
    isBusy: { type: Boolean, default: false },
  },
  emits: ["showDetail"],
  computed: {
    canShowDetail() {
      return (
        !this.isBusy &&
        typeof this.item.template_uuid === "string" &&
        this.item.template_uuid.trim().length > 0
      );
    },
    getClaimBeginText() {
      return formatCouponDateTime(
        this.item.claim_begin_at,
        this.item.timezone_name,
        COUPON_DATE_FORMAT
      );
    },
    getClaimEndText() {
      return formatCouponDateTime(
        this.item.claim_end_at,
        this.item.timezone_name,
        COUPON_DATE_FORMAT
      );
    },
  },
  methods: {
    showDetail() {
      if (this.canShowDetail) this.$emit("showDetail", this.item.template_uuid);
    },
    onCardClick(event) {
      if (!event.target.closest("button")) this.showDetail();
    },
    onCardKeydown(event) {
      if (
        event.target !== event.currentTarget ||
        !["Enter", " "].includes(event.key)
      ) return;
      event.preventDefault();
      this.showDetail();
    },
  },
};
</script>
<style scoped>
.public_coupon_template {
  box-sizing: border-box;
  width: 100%;
  display: flex;
  gap: 12px;
  padding: 12px 16px;
  background: #fff;
  border-bottom: 1px dashed #cfcfcf;
  margin-bottom: 10px;
}
.public_coupon_content {
  flex: 1;
  min-width: 0;
}
.is_clickable {
  cursor: pointer;
}
.is_clickable:focus-visible {
  outline: 2px solid #fd5001;
  outline-offset: -2px;
}
.public_coupon_content h3 {
  margin: 0 0 4px;
  font-size: 17px;
  font-weight: 600;
  color: #000;
}
.public_coupon_content p {
  margin: 4px 0;
}
.public_coupon_description {
  font-size: 13px;
  color: #666;
}
.public_coupon_period {
  font-size: 12px;
  color: #a45721;
}
.coupon_action {
  align-self: center;
  flex-shrink: 0;
  max-width: 42%;
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  background: #fbcb02;
  color: #000;
  font-size: 15px;
  font-weight: 600;
}
.public_coupon_template p,
.public_coupon_template h3 {
  overflow-wrap: anywhere;
}
.public_coupon_template button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
</style>
